"use strict";
exports.__esModule = true;
var angular = require("angular");
var onboarding_component_1 = require("../../../../../../components/onboarding/onboarding.component");
angular.module('smartorg.r6.navs.navbar', [onboarding_component_1["default"]]);
require('./navbar-directive');
require('../../css/app.css');
module.exports = 'smartorg.r6.navs.navbar';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/navbar/app/js/plumbing/app.js